import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'td-wb-empty-sub-header',
    template: '<ng-content />',
    styleUrls: ['empty-sub-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptySubHeaderComponent {
}
